import React, { useEffect } from "react";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import Breadcrumb from "../components/Breadcrumb/Breadcrumb";
import CaseStudyCard from "../components/CaseStudyComp/CaseStudyCard";
import CaseStudyData from "../Data/CaseStudyData/CaseStudyData";
import usePageMeta from "../Helpers/usePageMeta";

const CaseStudy = () => {
  usePageMeta({
    title: "Case Studies | TZ Creation",
    description:
      "Real projects led by TZ Creation's founder -- healthcare platforms, SaaS, EdTech and more, each with the full case study.",
    path: "/case-study",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <Breadcrumb parentpageName="Home" currentPageName="Case Studies" />
      <section className="section-gap">
        <div className="container">
          <div className="cs-intro">
            <h2>Selected work led by our founder</h2>
            <p>
              Projects led by our founder, Tabrez Dal — product design and
              front-end engineering across healthcare, SaaS and EdTech. Full
              write-ups are on his portfolio.
            </p>
          </div>
          <div className="row g-4">
            {CaseStudyData.map((item) => (
              <CaseStudyCard key={item.title} item={item} />
            ))}
          </div>
          <div className="text-center mt-5">
            <a
              className="primary-btn text-uppercase"
              href="https://tabrezdal.com/case-studies/"
              target="_blank"
              rel="noopener noreferrer"
            >
              See all case studies
            </a>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default CaseStudy;
